// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const AuratypesCloudProvider = {
  CloudProviderGCP: 'gcp',
  CloudProviderAWS: 'aws',
  CloudProviderAzure: 'azure',
} as const;
export type AuratypesCloudProvider =
  (typeof AuratypesCloudProvider)[keyof typeof AuratypesCloudProvider];

export function instanceOfAuratypesCloudProvider(value: any): boolean {
  for (const key in AuratypesCloudProvider) {
    if (Object.prototype.hasOwnProperty.call(AuratypesCloudProvider, key)) {
      if (
        AuratypesCloudProvider[key as keyof typeof AuratypesCloudProvider] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AuratypesCloudProviderFromJSON(
  json: any,
): AuratypesCloudProvider {
  return AuratypesCloudProviderFromJSONTyped(json, false);
}

export function AuratypesCloudProviderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuratypesCloudProvider {
  return json as AuratypesCloudProvider;
}

export function AuratypesCloudProviderToJSON(
  value?: AuratypesCloudProvider | null,
): any {
  return value as any;
}

export function AuratypesCloudProviderToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AuratypesCloudProvider {
  return value as AuratypesCloudProvider;
}
